var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"id":"hp-logo","src":"/static/img/logo/HPB-logo-on-white.svg","srcset":""}}),_vm._v(" "),_c('qrcode-vue',{attrs:{"value":_vm.businessCopyUrl,"size":_vm.size,"level":"H"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3414c030","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/ReviewQRCodesWidget.vue
// module id = null
// module chunks = 